import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MailCheck, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const BTN = "flex w-full items-center justify-center gap-2 rounded-full bg-rose-600 py-2.5 text-sm font-bold text-white transition-colors hover:bg-rose-700 disabled:opacity-40";

export function EmailConfirm({ onDone }) {
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [wait, setWait] = useState(0);
  useEffect(() => {
    if (wait <= 0) return undefined;
    const t = setTimeout(() => setWait((w) => w - 1), 1000);
    return () => clearTimeout(t);
  }, [wait]);
  const run = async (fn) => {
    setBusy(true);
    try {
      await fn();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  const send = (e) => {
    e?.preventDefault();
    run(async () => {
      const { data } = await api.post("/auth/email-precheck/start", { email });
      setSent(true);
      setWait(60);
      if (data.sandbox_code) setCode(data.sandbox_code);
      toast.success("Ti abbiamo inviato un codice a 6 cifre");
    });
  };
  const verify = (e) => {
    e.preventDefault();
    run(async () => {
      const { data } = await api.post("/auth/email-precheck/verify", { email, code });
      toast.success("Email confermata");
      onDone(email.toLowerCase(), data.precheck_token);
    });
  };
  return (
    <div className="space-y-4" data-testid="operator-email-confirm">
      <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-rose-500">Conferma email</p>
      <form onSubmit={send} className="space-y-2">
        <Label>La tua email professionale</Label>
        <Input data-testid="operator-precheck-email" type="email" required disabled={sent} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="nome@esempio.it" />
        {!sent && <button data-testid="operator-precheck-send" disabled={busy || wait > 0} className={BTN}>{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <MailCheck className="h-4 w-4" />}{wait > 0 ? `Nuovo codice tra ${wait} s` : "Invia codice di conferma"}</button>}
      </form>
      {sent && (
        <form onSubmit={verify} className="space-y-2" data-testid="operator-precheck-code-form">
          <Label>Codice ricevuto via email</Label>
          <Input data-testid="operator-precheck-code" inputMode="numeric" maxLength={6} required className="tracking-[0.4em]" value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} placeholder="000000" />
          <button data-testid="operator-precheck-verify" disabled={busy || code.length !== 6} className={BTN}>Conferma email e continua</button>
          <button type="button" data-testid="operator-precheck-resend" disabled={busy || wait > 0} onClick={() => send()} className="w-full text-xs font-semibold text-rose-600 underline disabled:text-slate-400 disabled:no-underline">{wait > 0 ? `Puoi richiedere un nuovo codice tra ${wait} s` : "Invia di nuovo il codice"}</button>
          <button type="button" data-testid="operator-precheck-change" onClick={() => { setSent(false); setCode(""); }} className="w-full text-xs text-slate-500 underline">Cambia email</button>
        </form>
      )}
    </div>
  );
}
